var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("TargetChange.Description")))]),
      _vm._v(" "),
      _c("text-label-row", {
        ref: "aid-target-number",
        attrs: { title: "AidTargetNumber", value: _vm.request.aidTargetNumber }
      }),
      _vm._v(" "),
      _c("text-label-row", {
        ref: "purpose",
        attrs: { title: "Purpose", value: _vm.request.purpose }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        ref: "new-aid-target",
        attrs: {
          title: "TargetChange.NewAidTarget",
          instructionsKey: "PurposeChange.Instruction",
          required: true,
          maxLength: 100,
          rows: 2
        },
        model: {
          value: _vm.request.newAidTarget,
          callback: function($$v) {
            _vm.$set(_vm.request, "newAidTarget", $$v)
          },
          expression: "request.newAidTarget"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "TargetChange.ApproximateAmount",
          id: "approximateamount",
          required: true
        },
        model: {
          value: _vm.request.approximateAmount,
          callback: function($$v) {
            _vm.$set(_vm.request, "approximateAmount", $$v)
          },
          expression: "request.approximateAmount"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        ref: "arguments",
        attrs: {
          title: "TargetChange.Arguments",
          instructionsKey: "PurposeChange.Instruction",
          required: true,
          maxLength: 4000,
          rows: 5
        },
        model: {
          value: _vm.request.arguments,
          callback: function($$v) {
            _vm.$set(_vm.request, "arguments", $$v)
          },
          expression: "request.arguments"
        }
      }),
      _vm._v(" "),
      _c("attachment-row", {
        attrs: {
          title: "TargetChange.Approval",
          attachment: _vm.request.approval,
          index: 0
        },
        model: {
          value: _vm.request.approval,
          callback: function($$v) {
            _vm.$set(_vm.request, "approval", $$v)
          },
          expression: "request.approval"
        }
      }),
      _vm._v(" "),
      _c("attachment-row", {
        attrs: {
          title: "TargetChange.ReceiverApproval",
          attachment: _vm.request.receiverApproval,
          index: 1
        },
        model: {
          value: _vm.request.receiverApproval,
          callback: function($$v) {
            _vm.$set(_vm.request, "receiverApproval", $$v)
          },
          expression: "request.receiverApproval"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }